// extracted by mini-css-extract-plugin
export var actions = "_ac-8";
export var arrow = "_ac-5";
export var card = "_ac-0";
export var cardWrapper = "_ac-9";
export var fieldName = "_ac-3";
export var newValue = "_ac-6";
export var oldValue = "_ac-4";
export var orangeGlowFade = "_ac-c";
export var productSection = "_ac-1";
export var scrollToBottom = "_ac-b";
export var scrollToBottomAnchor = "_ac-a";
export var scrollToBottomIcon = "_ac-d";
export var showAllButton = "_ac-7";
export var table = "_ac-2";